export const AppSettings = {
    'IS_FIREBASE_ENABLED': false,
    'SHOW_START_WIZARD': false,
    'SUBSCRIBE': false,
    'FIREBASE_CONFIG': {
      'apiKey': "AIzaSyA-6Td6cLYYjEeBtDpy9oqULEb_i6bYBCE",
      'authDomain': "ionic-letto-thema.firebaseapp.com",
      'databaseURL': "https://ionic-letto-thema.firebaseio.com",
      'projectId': "ionic-letto-thema",
      'storageBucket': "ionic-letto-thema.appspot.com",
      'messagingSenderId': "357544485321",
      'appId': "1:357544485321:web:001d15a5e558e0ca964818",
      'measurementId': "G-DNV3J03J4N"
    }
};
